/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CANT_DELETE_TASK_REASON = "BLOCKED_BY_SUBTASK" | "GITHUB" | "HAS_INVOICED_TIME" | "HAS_LOCKED_TIME" | "HAS_OTHER_PEOPLES_TIME_REGS" | "HAS_TIME_REGS" | "JIRA" | "NO_USER_TYPE" | "UNIT4" | "%future added value";
export type ValidateCanUserDeleteTaskInput = {|
  taskId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ValidateCanUserDeleteTaskMutationVariables = {|
  input: ValidateCanUserDeleteTaskInput
|};
export type ValidateCanUserDeleteTaskMutationResponse = {|
  +validateCanUserDeleteTask: ?{|
    +userCanDeleteTask: ?boolean,
    +userCantDeleteTaskReason: ?CANT_DELETE_TASK_REASON,
  |}
|};
export type ValidateCanUserDeleteTaskMutation = {|
  variables: ValidateCanUserDeleteTaskMutationVariables,
  response: ValidateCanUserDeleteTaskMutationResponse,
|};
*/


/*
mutation ValidateCanUserDeleteTaskMutation(
  $input: ValidateCanUserDeleteTaskInput!
) {
  validateCanUserDeleteTask(input: $input) {
    userCanDeleteTask
    userCantDeleteTaskReason
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ValidateCanUserDeleteTaskInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateCanUserDeleteTaskPayload",
    "kind": "LinkedField",
    "name": "validateCanUserDeleteTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userCanDeleteTask",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userCantDeleteTaskReason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateCanUserDeleteTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateCanUserDeleteTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ValidateCanUserDeleteTaskMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateCanUserDeleteTaskMutation(\n  $input: ValidateCanUserDeleteTaskInput!\n) {\n  validateCanUserDeleteTask(input: $input) {\n    userCanDeleteTask\n    userCantDeleteTaskReason\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '42b34f287aff9a3091d7a852eab032b6';

module.exports = node;
